import React from 'react';
import { MailList } from '../components/MailList';
import { PageHeader } from '@/components/layout/PageContainer';
import { SearchOutline, MoreOutline } from 'antd-mobile-icons';

export const MailPage: React.FC = () => {
    return (
        <div className="min-h-[100dvh] bg-black text-white pt-safe pb-20">
            <PageHeader
                title="信件"
                right={
                    <>
                        <SearchOutline fontSize={24} />
                        <MoreOutline fontSize={24} />
                    </>
                }
            />
            <MailList />
        </div>
    );
};
